import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * Centralizes caching strategy for the entire application
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Data is immediately stale - always refetch when needed
      gcTime: 5 * 60 * 1000,   // 5 minutes - cached data is garbage collected after this (formerly cacheTime)
      retry: 1,                  // Retry failed requests once
      refetchOnWindowFocus: false, // Prevent aggressive refetching when user returns to tab
      refetchOnReconnect: true,    // Refetch when internet connection is restored
    },
    mutations: {
      retry: 0, // Don't retry mutations automatically
    },
  },
});
